import api from './index';
//
let exports = {};

//
exports.sendSmsForRegist = function (params, callback) {// 发送短信验证码，注册用
    api.post('/notify/sms/send/for/regist/do')
    .data(params)
    .done(callback)
    .go();
};
// 重置密码发送验证码
exports.sendSmsForLogPass = function (params, callback) {// 发送短信验证码，找回登录密码用
    api.post('/notify/sms/send/for/logPass/do')
    .data(params)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/notify.js
// module id = 203
// module chunks = 1